<template>
  <iframe width="100%" height="100%" :src="uri"></iframe>
</template>

<script>
// test
//import ComponentInWorker from "@/components/ComponentInWorker";
export default {
  name: "trainingMview",
  data() {
    return {
      uri: "https://apicloud.magycorp.com:48028/docs/MAGYPAGO/CONTRATO%20MAGYPAGO%202022.DOCX.pdf"
    };
  }
};
</script>

<style></style>
